import { createSlice } from "@reduxjs/toolkit";
import { ICDSLState, INominee } from "../../Pages/Step7/NomineeTypes";
import api from "../../Services/ApiServices";
import AuthInfoContext from "../../Types/AuthInfoContext";
import { IOTPSession } from "../../Types/OTPSession";
import { dispatch, RootState } from "../store";
import { setAuthInfo, setStage } from "./common";

interface INomineeLoadRecords1 {
  CanEditNominee: true;
  HasAnyQuery: false;
  LastNomineeCustomQueryReason: "";
  NomineeCheckRWPBSInternalCode: 1;
  CorrAddressLine1: string;
  CorrAddressLine2: string;
  CorrAddressLine3: string;
  CorrAddressCity: string;
  CorrAddressPinCode: string;
  CorrAddressDistrict: string;
  CorrAddressStateName: string;
  CorrAddressCountryName: string;
}
interface IStep6State {
  isLoading?: boolean;
  error?: any;
  nomineeList?: INominee[];
  CanEditNominee?: boolean;
  HasAnyQuery?: boolean;
  LastNomineeCustomQueryReason?: string;
  NomineeCheckRWPBSInternalCode?: number;

  lstState?: ICDSLState[];
  records1?: INomineeLoadRecords1;

  saveDetailLoading?: boolean;
  saveDetailError?: any;
  saveDetail?: IOTPSession;

  isAnyActionPerformed: boolean;
}

const initialState: IStep6State = { isAnyActionPerformed: false };

const slice = createSlice({
  name: "stage7",
  initialState,
  reducers: {
    //loading
    startLoading(state) {
      state.isLoading = true;
      state.error = undefined;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getNomineeSuccess(state, action) {
      state.isLoading = false;
      state.nomineeList = action.payload.Records;
      if (action.payload.Records1 && action.payload.Records1[0]) {
        state.records1 = action.payload.Records1[0];

        state.CanEditNominee = action.payload.Records1[0].CanEditNominee;
        state.LastNomineeCustomQueryReason =
          action.payload.Records1[0].LastNomineeCustomQueryReason;
        state.NomineeCheckRWPBSInternalCode =
          action.payload.Records1[0].NomineeCheckRWPBSInternalCode;
        state.HasAnyQuery = action.payload.Records1[0].HasAnyQuery;
      }
      if (action.payload.Records2) {
        state.lstState = action.payload.Records2;
      }
    },

    saveDetailStartLoading(state) {
      state.saveDetailLoading = true;
      state.saveDetailError = undefined;
    },
    saveDetailHasError(state, action) {
      state.saveDetailLoading = false;
      state.saveDetailError = action.payload;
    },
    saveDetailSuccess(state, action) {
      state.saveDetail = action.payload;
      state.saveDetailLoading = false;
    },
    setActionPerformed(state, action) {
      state.isAnyActionPerformed = action.payload;
    },
    resetFields() {
      return { ...initialState };
    },
  },
});

// Reducer
export default slice.reducer;

export const { resetFields, setActionPerformed, saveDetailHasError } =
  slice.actions;

export const fetchExistingNomineeList = () => {
  return async (disp: any, getState: () => RootState) => {
    try {
      await dispatch(slice.actions.startLoading());

      const { objAuthInfoResponse } = getState().common;
      let response = await api.ReturnExistingNomineeList({
        AOSAI: JSON.stringify(objAuthInfoResponse),
      });
      await dispatch(slice.actions.getNomineeSuccess(response));
    } catch (ex) {
      console.log(ex, "ex");
      await dispatch(slice.actions.hasError(ex));
    }
  };
};

export const saveNomineeDetail = ({ HNN }: { HNN: number }) => {
  return async (disp: any, getState: () => RootState) => {
    try {
      await dispatch(slice.actions.saveDetailStartLoading());

      const { objAuthInfoResponse } = getState().common;
      let response = await api.SaveNomineeDetails({
        AOSAI: JSON.stringify(objAuthInfoResponse),
        HNN,
      });
      // await dispatch(setStage(8.0)); // Temp

      const objAuthContext = new AuthInfoContext(
        response.ContextSystemObjectIDOrCode
      );
      if (!objAuthContext.Status) throw new Error(objAuthContext.Message);
      await dispatch(slice.actions.saveDetailSuccess(response));
      await dispatch(setAuthInfo(response));
      await dispatch(setStage(objAuthContext.NextStage));
    } catch (ex) {
      console.log(ex, "ex");
      await dispatch(slice.actions.saveDetailHasError(ex));
    }
  };
};
